import { Box, Button, Checkbox, Paper, TextField, Typography } from "@mui/material";
import { useAuthStore } from "../../../store/auth.store";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

export function RegistrationPassword() {
    const navigate = useNavigate();
    const {
        isAcceptedRegistration,
        registrationEmail,
        sendPassword,
    } = useAuthStore();
    if (!isAcceptedRegistration) navigate("/");

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [error, setError] = useState("");
    const [errorRepeat, setErrorRepeat] = useState("");

    const [privacyChecked, setPrivacyChecked] = useState(false);

    const handlePrivacyCheck = () => {
        setPrivacyChecked(!privacyChecked);
    };

    const handleChangePassword = (event: any) => {
        setPassword(event.target.value);
    };

    const handleChangePasswordRepeat = (event: any) => {
        if (event.target.value != password)
            setErrorRepeat("Пароли не совпадают");
        else setErrorRepeat("");
        setPasswordRepeat(event.target.value);
    };

    const handleSendPassword = () => {
        if (password != passwordRepeat) return setErrorRepeat("Пароли не совпадают");
        if (!privacyChecked) return enqueueSnackbar({
            message: "Вы не согласились с пользовательским соглашением и политикой конфиденциальности",
            variant: "error"
        })
        else setErrorRepeat("");
        sendPassword(password);
    };

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "40px",
                    margin: "0 40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                    gap: "8px",
                }}
            >
                <h1>Регистрация пользователя</h1>
                <Typography>Введите пароль для завершения регистрации аккаунта {registrationEmail}</Typography>
                <TextField
                    error={error != ""}
                    helperText={error}
                    value={password}
                    onChange={handleChangePassword}
                    placeholder="Пароль"
                    type="password"
                />
                <TextField
                    error={errorRepeat != ""}
                    helperText={errorRepeat}
                    value={passwordRepeat}
                    onChange={handleChangePasswordRepeat}
                    placeholder="Повтор пароля"
                    type="password"
                />
                <Box><Checkbox checked={privacyChecked} onChange={() => handlePrivacyCheck()} /> Я согласен с <a href="/agreement.pdf" target="_blank">пользовательским соглашением</a> и <a href="/privacy.pdf" target="_blank">политикой конфиденциальности</a></Box>
                <Button variant="contained" onClick={handleSendPassword}>
                    Зарегистрироваться
                </Button>
            </Paper>
        </Box>
    );
}
